import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useResource } from 'src/hooks/useResource'
import { BackLink } from 'src/components/common'
import { createResourceRequest } from 'src/services/api.service'
import { useNotification } from 'src/contexts/notification.context'
import { useAuth } from 'src/contexts/auth.context'
import { routes } from 'src/navigation/routes'

import { generator } from 'src/services/generator'
import PracticeFormAuto from './form-auto'

export const TeacherNewAutogeneratedPractice = () => {
  const history = useHistory()
  const { user } = useAuth()
  const { showNotificationHelper } = useNotification()
  const [error, setError] = useState('')

  const { resourceType, resourceName, resourceCode } = useResource()

  const onSubmit = async (values) => {
    console.log('onSubmit', values)

    const { tasks, ...rest } = values

    try {
      const questions = []
      let level_ids = []

      let topic_id = null

      for (const task of tasks) {
        console.log('task', task)
        const problems = generator(task)
        for (const pr of problems) {
          questions.push({ level_id: task.level_id, ...pr })
          level_ids.push(task.level_id)
          if (task.topic_id) {
            topic_id = task.topic_id // TODO: only Last topic
          }
        }
      }
      level_ids = [...new Set(level_ids)]

      console.log('questions', questions, 'levels', level_ids)
      const response = await createResourceRequest(resourceType, {
        type: resourceCode,
        ...rest,
        questions,
        level_ids,
        levels: level_ids,
        topic_id,
      })

      const { item } = response.data
      const questionId =
        Array.isArray(item?.questions) && item?.questions[0]?.id
      history.push(routes[resourceType].questions.edit(item?.id, questionId))
      // const response = await getMixedTaskRequest(values);
      // history.replace(routes[resourceType].questions.index(response.data?.item?.id))
    } catch (error) {
      setError(error.response.data?.message)
      showNotificationHelper({
        type: 'fail',
        title: 'Error!',
        body: error.message,
      })
    }
  }

  return (
    <>
      <div className="sectionHb-top">
        <BackLink to={routes[resourceType].options} />
        <h2 className="sectionHb-title">
          New {resourceName}: <span className="blue__text">Auto-Generated</span>
        </h2>
      </div>

      <div className="sectionHb-block">
        <div className="sectionHb-block__wrap">
          <PracticeFormAuto
            onSubmit={onSubmit}
            error={error}
            initialValues={{
              grade_id: user.default_grade_id,
              subject_id: user.default_subject_id,
            }}
          />
        </div>
      </div>
    </>
  )
}
